import React, { useState, useEffect, Fragment } from 'react';
import { useDispatch } from 'react-redux';
import { Grid, Typography, Divider } from '@material-ui/core';
import DeleteCancel from "../../atoms/buttons/DeleteCancel";
import { invokePostService, invokeGetService, setInnerScreenRender } from "../../../store/global/actions";


export default function DeleteUserTrigger(props) {

    // console.log({props})

    const { userTriggerId, onClose, onCompletion, item } = props

    const dispatch = useDispatch();
    // const userTriggers = useSelector(getUserTriggers);
    // const userTrigger = userTriggers.find(item => item.id === userTriggerId)
    const [userTrigger, setUserTrigger] = useState(null)



    useEffect(() => {
        dispatch(invokeGetService('getSingleUt', [userTriggerId]))
            .then(result => {
                console.log('data ut---del-->', result)
                if (result.data !== undefined) {
                    console.log('res----->', result)
                    setUserTrigger(result.data)
                }
            })
            .catch(error => console.error(error));

    }, [])


    const onDelete = () => {
        // dispatch(deleteNodeAndAssociates({ node: userTrigger }));
        dispatch(invokePostService('deleteUserTrigger', {}, [userTriggerId]))
            .then(result => {
                if (result.data !== undefined) {
                    console.log('res----->', result)
                    dispatch(setInnerScreenRender())
                    onCompletion('User trigger', 'delete')
                }
            })
            .catch(error => console.error(error));

    }

    return (
        <>
            <Grid id={"delete_usertrigger_content"} container>
                <Grid item xs={12} style={{ marginBottom: 10 }}>
                    <Typography variant="h6">Delete</Typography>
                </Grid>
                <Grid item xs={12} >
                    <Divider />
                </Grid>
                <Grid xs={12} style={{ marginTop: 10, marginBottom: 10 }}>
                    <Fragment>
                        <Typography> Are you sure you want to delete the User Trigger {userTrigger?.name} ? </Typography>
                    </Fragment>
                </Grid>
                <Grid item xs={12} >
                    <Divider />
                </Grid>
                <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end", marginTop: 10 }} >
                    <DeleteCancel onCancel={onClose} onDelete={onDelete} />
                </Grid>
            </Grid>

        </>

    )
}